var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NextContactDone"},[_c('CheckBox',{attrs:{"value":_vm.record.nextContactDone},on:{"input":_vm.onCheckBoxClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }